import type { ComponentPropsWithoutRef, Ref } from "react";
import { forwardRef } from "react";

export const ReconizerLogo = forwardRef((props: ComponentPropsWithoutRef<"div">, ref: Ref<HTMLDivElement>) => {
  return (
    <div ref={ref} {...props}>
      <svg viewBox={`0 0 296 51`} fill="none" className="w-full">
        <path
          d="M271.24 28.2497C274.165 31.7496 277.056 35.2845 280 38.7679H277.069C275.954 38.7679 275.801 38.4486 275.027 37.5363C272.788 34.8735 269.351 30.7904 264.719 25.2872C265.175 25.2872 271.316 25.264 271.339 25.2872C273.398 25.2447 275.178 23.7803 275.225 21.6257C275.178 19.4758 273.406 17.9977 271.339 17.9977C266.563 17.9977 261.788 17.9977 257.012 17.9977C255.807 17.9977 254.839 17.1059 254.839 15.8674V15.0019C265.707 15.0019 271.152 15.0019 271.174 15.0019C274.932 14.9154 278.242 17.7357 278.287 21.6257C278.241 25.5039 275.01 28.3351 271.24 28.2497Z"
          fill="#F2F2F2"
        />
        <path
          d="M222.004 26.1859C222.004 25.7824 222.362 25.4204 222.761 25.4204H242.752V26.8517C242.752 27.7323 242.024 28.3827 241.171 28.3827H222.004V26.1859Z"
          fill="#F2F2F2"
        />
        <path
          d="M244.893 16.4665C244.893 17.3471 244.165 17.9977 243.312 17.9977H222.794C222.352 17.9977 222.004 17.6456 222.004 17.1988V15.0352H244.893V16.4665Z"
          fill="#F2F2F2"
        />
        <path
          d="M245.255 37.3366V38.7678H222.004V36.571C222.004 36.1444 222.342 35.8054 222.761 35.8054H243.674C244.528 35.8054 245.255 36.456 245.255 37.3366Z"
          fill="#F2F2F2"
        />
        <path
          d="M186.535 16.2335V15.0352H206.723C207.515 15.0352 208.271 15.448 208.271 16.3333V17.7646H188.116C187.263 17.7646 186.535 17.1141 186.535 16.2335Z"
          fill="#F2F2F2"
        />
        <path
          d="M208.271 37.3366V38.7679H186.535V37.4364C186.535 36.3492 186.919 35.4171 187.688 34.6405C195.35 27.3398 199.193 23.6783 199.215 23.6562C199.939 22.924 200.828 22.5577 201.882 22.5577H203.99C201.245 25.1318 196.679 29.5922 190.29 35.9386H206.69C207.498 35.9386 208.271 36.4597 208.271 37.3366Z"
          fill="#F2F2F2"
        />
        <path
          d="M175.404 38.7679H173.823C172.97 38.7679 172.242 38.1173 172.242 37.2367V15.0352H173.823C174.676 15.0352 175.404 15.6857 175.404 16.5664V38.7679Z"
          fill="#F2F2F2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M138.09 18.8964L153.042 38.3685C153.24 38.6347 153.503 38.7679 153.833 38.7679H157.06V15.0352H155.479C154.626 15.0352 153.898 15.6858 153.898 16.5664V34.9068L138.914 15.4346C138.716 15.1684 138.453 15.0352 138.123 15.0352H134.929V26.8517C134.929 27.7324 135.656 28.3827 136.51 28.3827H138.09V18.8964Z"
          fill="#F2F2F2"
        />
        <path
          d="M125.18 26.9015C125.18 33.6971 119.509 38.7679 112.929 38.7679C106.341 38.7679 100.645 33.7163 100.645 26.9015C100.645 20.1169 106.37 15.0352 112.929 15.0352C119.479 15.0352 125.18 20.136 125.18 26.9015ZM112.912 17.9977C107.953 17.9977 103.674 21.77 103.674 26.9015C103.674 32.033 107.953 35.8054 112.912 35.8054C117.872 35.8054 122.15 32.033 122.15 26.9015C122.15 21.7701 117.872 17.9977 112.912 17.9977Z"
          fill="#F2F2F2"
        />
        <path
          d="M81.5429 17.9977C76.575 17.9977 72.2886 21.7574 72.2886 26.9015C72.2886 32.0456 76.5749 35.8054 81.5429 35.8054H90.5666C91.0058 35.8054 91.3789 35.9553 91.6865 36.2548C91.9938 36.5544 92.1474 36.915 92.1474 37.3367V38.7679C84.8801 38.7679 81.1367 38.7679 80.9171 38.7679C78.7654 38.657 76.8005 38.0634 75.022 36.9871C71.4814 34.8445 69.2588 31.0952 69.2588 26.9015C69.2588 22.7079 71.4814 18.9587 75.022 16.8161C76.8005 15.7397 78.7654 15.1462 80.9171 15.0352C81.1367 15.0352 84.8801 15.0352 92.1474 15.0352V16.4665C92.1474 16.8881 91.9938 17.2487 91.6865 17.5483C91.3789 17.8478 91.0058 17.9977 90.5666 17.9977H81.5429Z"
          fill="#F2F2F2"
        />
        <path
          d="M35.8643 26.1859C35.8643 25.7824 36.2228 25.4204 36.6218 25.4204H56.6124C56.6124 26.6632 56.8125 28.3827 55.0316 28.3827H35.8643V26.1859Z"
          fill="#F2F2F2"
        />
        <path
          d="M58.7531 16.4665C58.7531 17.3471 58.0256 17.9977 57.1723 17.9977H36.6547C36.2126 17.9977 35.8643 17.6456 35.8643 17.1988V15.0352H58.7531V16.4665Z"
          fill="#F2F2F2"
        />
        <path
          d="M59.1153 37.3366V38.7678H35.8643V36.571C35.8643 36.1444 36.2022 35.8054 36.6218 35.8054H57.5345C58.3878 35.8054 59.1153 36.456 59.1153 37.3366Z"
          fill="#F2F2F2"
        />
        <path
          d="M16.4008 28.2497C19.3266 31.7496 22.2175 35.2845 25.1611 38.7679H22.2299C21.0742 38.7679 20.9617 38.4486 20.1882 37.5363C17.9487 34.8735 14.5126 30.7904 9.87998 25.2872C10.3361 25.2872 16.4767 25.264 16.4996 25.2872C18.5589 25.2447 20.3393 23.7803 20.3858 21.6257C20.3394 19.4758 18.567 17.9977 16.4996 17.9977C11.7243 17.9977 6.94885 17.9977 2.17354 17.9977C0.967629 17.9977 0 17.1059 0 15.8674V15.0019C10.868 15.0019 16.313 15.0019 16.335 15.0019C20.093 14.9154 23.403 17.7357 23.4485 21.6257C23.4025 25.5039 20.1709 28.3351 16.4008 28.2497Z"
          fill="#F2F2F2"
        />
        <path
          d="M112.912 30.6837C114.979 30.6837 116.654 28.9903 116.654 26.9015C116.654 24.8126 114.979 23.1193 112.912 23.1193C110.845 23.1193 109.17 24.8126 109.17 26.9015C109.17 28.9903 110.845 30.6837 112.912 30.6837Z"
          fill="#D69B2D"
        />
        <path
          d="M133.227 49.6738L131.977 50.652C131.63 50.9237 131.244 51.0364 130.82 50.9897C130.395 50.9431 130.055 50.753 129.8 50.4197L121.062 39.0169L122.312 38.0386C122.66 37.7669 123.045 37.6542 123.47 37.7009C123.894 37.7475 124.234 37.9377 124.49 38.2709L133.227 49.6738Z"
          fill="#F2F2F2"
        />
        <path
          d="M285.979 4V5.41H284.029V11H282.509V5.41H280.569V4H285.979ZM295.285 11H293.745L293.055 6.43L290.965 10.99H290.595L288.505 6.43L287.815 11H286.265L287.365 4H288.885L290.775 8.29L292.675 4H294.195L295.285 11Z"
          fill="#F2F2F2"
        />
      </svg>
    </div>
  );
});
